// @material-ui/icons
import {
  Dashboard,
  Person,
  LibraryBooks,
  List,
  Equalizer,
  Timeline,
  Settings,
  Money,
  History,
  Email,
  Help,
  LiveHelp,
  AccountBalanceWallet,
  AccountBalance,
  ExitToApp,
  ArrowForwardIcon,
  Edit
} from "@material-ui/icons";

const dashboardRoutes = [
  {
    id: "login",
    path: "/login",
    isSideMenu: false,
    isEdit: false,
    isRestricted: "common",
  },


  {
    id: "edit-profile",
    path: "/editprofile",
    isSideMenu: false,
    isEdit: false,
    isRestricted: "common",
  },

  /* Dashboard */
  // {
  //   id: "dashboard",
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: Dashboard,
  //   isSideMenu: true,
  //   isEdit: false,
  //   isRestricted: "single",
  // },

  /* Dashboard */
  // {
  //   path: "#",
  //   id: "dashboard",
  //   name: "Dashboard",
  //   icon: List,
  //   type: "multi",
  //   isEdit: false,
  //   isSideMenu: true,
  //   child: [
  //     {
  //       name: "Dashboard Lists",
  //       path: "/dashboard",
  //       icon: Person,
  //     },
  //   ],
  // },

  // {
  //   path: "#",
  //   id: "faq",
  //   name: "FAQ",
  //   icon: LiveHelp,
  //   type: "multi",
  //   isEdit: false,
  //   isSideMenu: true,
  //   child: [
  //     {
  //       name: "FAQ List",
  //       path: "/faqList",
  //       icon: List,
  //     },
  //   ],
  // },
  {
    path: "#",
    id: "Settings",
    name: "Settings",
    icon: Settings,
    type: "multi",
    isEdit: false,
    isSideMenu: true,
    child: [
      {
        name: "Setting",
        path: "/Setting",
        icon: Settings,
      },
    ],
  },
  {
    path: "#",
    id: "History",
    name: "History",
    icon: History,
    type: "multi",
    isEdit: false,
    isSideMenu: true,
    child: [
      {
        name: "Buy History",
        path: "/history",
        icon: List,
      },
    ],
  },

  {
    path: "#",
    id: "faq",
    name: "FAQ",
    icon: List,
    type: "multi",
    isEdit: false,
    isSideMenu: true,
    child: [
      {
        name: "List",
        path: "/faqList",
        icon: List,
      },
      {
        name: "Add",
        path: "/faqAdd",
        icon: Edit,
      },
    ],
  },
];

export default dashboardRoutes;
